// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:36:33

export default {
  "id": "hotfoot-baseball",
  "slug": "hotfoot-baseball",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/e2c035f654cf4b1d91f6d4c57b649b50-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/e2c035f654cf4b1d91f6d4c57b649b50/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Hotfoot Baseball",
      "description": "Simple baseball game with fun, cartoony players and easy one-click controls. It’s fast to learn and fun to play!\n\nUnlike other baseball games, the action doesn’t stop after you hit the ball. You need to decide when to run, move to the next base, and try to score runs. It’s all about timing and quick decisions.\n\nPick one of the best baseball countries and try to win the championship. The game keeps the excitement of baseball but with simple rules, so anyone can enjoy it.",
      "instructions": "Tap anywhere to swing the bat. When your player reaches the base, tap him to run to the next base.",
      "genres": [
        "Sports"
      ],
      "tags": [
        "baseball"
      ]
    },
    "zh-CN": {
      "title": "热脚棒球",
      "description": "简单棒球游戏，拥有有趣、卡通化的球员和易于操作的单击控制。学习快速，玩法有趣！\n\n与其他棒球游戏不同，击球后动作并不会停止。你需要决定何时奔跑、移动到下一个垒，并尝试得分。这一切都关乎时机和快速决策。\n\n选择一个最佳的棒球国家，努力赢得冠军。游戏保留了棒球的激情，但规则简单，任何人都能享受其中。",
      "instructions": "点击任何地方挥棒。当玩家到达垒时，点击他使他跑到下一个垒。",
      "genres": [
        "运动"
      ],
      "tags": [
        "棒球"
      ]
    },
    "zh-TW": {
      "title": "熱腳棒球",
      "description": "簡單的棒球遊戲，帶有有趣、卡通化的球員和簡單的一鍵操控。學習快速，遊玩樂趣！\n\n與其他棒球遊戲不同，當你擊出球後，動作不會就此停滯。你需要決定何時奔跑、移動到下一個壘包，並試著得分。一切都關乎時間和迅速的決策。\n\n選擇一個最好的棒球國家，並試圖奪得冠軍。遊戲保持了棒球的速度和興奮，但規則簡單，所以任何人都能享受遊戲。",
      "instructions": "隨處點擊即可揮棒。當你的選手抵達壘包時，點擊他即可跑到下一個壘包。",
      "genres": [
        "運動"
      ],
      "tags": [
        "棒球"
      ]
    },
    "zh-HK": {
      "title": "急步打棒球",
      "description": "簡單的棒球遊戲，有有趣、卡通化的球員和簡單的一鍵控制。易學易玩！\n\n與其他棒球遊戲不同，你擊中球後動作不會停止。你需要決定何時奔跑、移動到下一個壘位，並試圖得分。這一切都關乎時間掌握和迅速決策。\n\n選擇一個最佳的棒球國家，並試圖奪得冠軍。遊戲保持了棒球的刺激感，但規則簡單，所以任何人都能享受遊戲。",
      "instructions": "按任何地方以揮動球棒。當你的球員達到壘時，按他使他跑到下一壘。",
      "genres": [
        "運動"
      ],
      "tags": [
        "棒球"
      ]
    },
    "ja": {
      "title": "ホットフット野球",
      "description": "シンプルな野球ゲームで、楽しいカートゥーン風の選手たちが登場。簡単な一クリックで操作できます。すぐに覚えやすいし、楽しいです！\n\n他の野球ゲームとは異なり、ボールを打った後でもアクションは停止しません。走るタイミング、次のベースに移動するタイミング、ランを得点しようとするタイミングを決めなくてはなりません。すべてはタイミングと素早い判断のことです。\n\n最も優れた野球国のひとつを選び、チャンピオンシップを目指してください。ゲームは野球の興奮を保ちつつ、シンプルなルールで誰でも楽しめます。",
      "instructions": "バットを振るためにどこでもタップしてください。プレイヤーがベースに到達したら、ベースに進むためにプレイヤーをタップしてください。",
      "genres": [
        "スポーツ"
      ],
      "tags": [
        "野球"
      ]
    },
    "ko": {
      "title": "화끈한 야구",
      "description": "쉬운 베이스볼 게임으로, 재미있는 카툰형 선수들과 쉬운 한번에 클릭하는 조작으로 즐길 수 있습니다. 빠르게 배우고 즐길 수 있습니다!\n\n그런 다른 베이스볼 게임과 달리, 공을 치면 행동이 멈추지 않습니다. 언제 뛰어들지, 다음 배지로 이동할지, 득점을 시도할지 결정해야 합니다. 모든 것이 시간과 빠른 결정에 관련됩니다.\n\n최고의 베이스볼 국가 중 하나를 선택하고 챔피언십을 이기세요. 이 게임은 베이스볼의 흥분을 유지하면서도 간단한 규칙으로 누구나 즐길 수 있습니다.",
      "instructions": "놀이공원 어디든 탭하여 막대기를 쳐라. 플레이어가 본垒에 도달하면 그를 탭하여 다음 본垒으로 달려가도록 하라.",
      "genres": [
        "스포츠"
      ],
      "tags": [
        "야구"
      ]
    },
    "fr": {
      "title": "Baseball en Pleine Fierté",
      "description": "Jeu de baseball simple avec des joueurs amusants et mignons, et des contrôles un clic facile. Il est rapide à apprendre et amusant à jouer !\n\nContrairement à d'autres jeux de baseball, l'action ne s'arrête pas après que vous ayez frappé la balle. Vous devez décider quand courir, vous diriger vers la prochaine base, et tenter de marquer des points. C'est tout question de timing et de décisions rapides.\n\nChoisissez l'un des meilleurs pays de baseball et essayez de gagner le championnat. Le jeu conserve l'excitation du baseball mais avec des règles simples, afin que tout le monde puisse en profiter.",
      "instructions": "Appuyez n'importe où pour frapper avec le batte. Lorsque votre joueur atteint la base, appuyez sur lui pour courir à la prochaine base.",
      "genres": [
        "Sports"
      ],
      "tags": [
        "baseball"
      ]
    }
  }
};
